module.exports = __webpack_public_path__ + "static/media/marker-icon-2x-b7b7b7.0108950e.png";